module.exports = __webpack_public_path__ + "img/novelty-pic-pc.ecc662df.png";